import React from "react";
import axios from 'axios';

import MenuContextProvider from "../../context/menu-context";
import PageContainer from "../../components/PageContainer";
import HeaderOne from "../../components/header-one";
import ArtistImage from "../../components/artistImage";
import ArtistMenu from "../../components/artistMenu";
import ArtistSummary from "../../components/artistSummary"
import FeaturedAlbums from "../../components/featuredAlbums";
import ContactArtist from "../../components/contactArtist";
import Footer from "../../components/footer";
import SocialMediaBanner from "../../components/socialMediaBanner";
import SummaryImage from "../../assets/images/goffMideon/summaryImage.jpg";
import backgroundImage from "../../assets/images/bg/goffMideon.png";
import welcomeToTheHalfHouse from "../../assets/images/releases/welcomeToTheHalfHouse.png";

class GoffMideon extends React.Component {

    componentDidMount() {
        axios.get(`https://jsonplaceholder.typicode.com/users`)
            .then(res => {
                const persons = res.data;
                this.setState({ persons });
            })
    }
    state = {
        artist: "Goff Mideon",
        artistRealName: "",
        artistNameLink: "goffMideon",
        artistEmail: "goffmideon@halfhousestudios.com",
        backgroundImage: backgroundImage,
        SummaryImage: SummaryImage,
        spotifyArtistLink: "https://open.spotify.com/embed/artist/13v0fOzWzB0XdbyzczOgjG?utm_source=generator&theme=0",
        artistSummaryP1: "Goff Mideon, formerly known as A I R I, is renowned for his contribution to Half House's discography. He holds a degree from the University of Wisconsin-Milwaukee, where he studied film and acting. ",
        artistSummaryP2: "After seeing the potential of his hometown and shooting some music videos while visiting, he moved into Half House to further his musical career, as well as take up the role of lead filmmaker. " +
            "As such, he is responsible for all video production, ranging from podcasts and interviews to skits and music videos for Half House Studios.",
        artistPageMenu: [
            {
                name: "Releases",
                url: "#releases"
            },
            {
                name: "Videos",
                url: "#videos",
            },
            {
                name: "Contact",
                url: "#contact"
            }
        ],
        artistReleases: [
            {
                title: "Welcome To HalfHouse",
                image: welcomeToTheHalfHouse,
                url: "https://open.spotify.com/album/4u4VnzdDPXlSsJ63JJiY3o?si=T_5vuEVmSama2pICeG7D5w"
            },
        ],
        index: 0,
        mainSlideOptions: {
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: "#main-slider-next",
                prevEl: "#main-slider-prev"
            }
        },
        socialMedia: [
            {
                name: "Youtube",
                url: "https://www.youtube.com/@GoffMideon"

            },
            {
                name: "TikTok",
                url: "https://www.tiktok.com/@goff_mideon"

            },
            {
                name: "Instagram",
                url: "https://www.instagram.com/goffmideon/"

            },
            {
                name: "Twitter",
                url: "https://twitter.com/goff_mideon"

            }

        ]
    }
    render() {
        return (
            <MenuContextProvider>
                <PageContainer>
                    <HeaderOne/>
                    <ArtistImage bgImage={this.state.backgroundImage} artist={this.state.artist}/>
                    <ArtistMenu data={this.state}/>
                    <SocialMediaBanner data={this.state.socialMedia} />
                    <ArtistSummary data={this.state}/>
                    <FeaturedAlbums data={this.state}/>
                    <ContactArtist artistEmail={this.state.artistEmail} />
                    <Footer />
                </PageContainer>
            </MenuContextProvider>
        )
    }
}

export default GoffMideon;